import Vue from "vue";

Vue.filter("currency", (value, decimals) => {
    return "$" + value.toFixed(decimals).toLocaleString();
});

Vue.filter('moneda', function(value, decimals) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: decimals
    })
    return formatter.format(value);
});